var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from "react";
import { Popup } from "@atlaskit/popup";
import AButton from "@atlaskit/button";
import "./classifications";
import WizardHelpContent from "./wizardhelpcontent";
var WizardHelp = function (props) {
    var _a = useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var toggleShowhelp = function () { setIsOpen(false); };
    return (React.createElement(Popup, { isOpen: isOpen, onClose: function () { return setIsOpen(false); }, content: function () { return (React.createElement("div", { className: "popup-wrapper" },
            React.createElement("div", { className: "popup-content" },
                props.platform !== "micros" &&
                    React.createElement(React.Fragment, null,
                        React.createElement(WizardHelpContent, { onSelect: props.onSelect, selectedClassifications: props.classificationList, closeClicked: toggleShowhelp, onSubmit: props.onSubmit })),
                props.platform === "micros" &&
                    React.createElement(React.Fragment, null,
                        React.createElement(WizardHelpContent, { onSelect: props.onSelect, selectedClassifications: props.classificationList, closeClicked: toggleShowhelp }))))); }, trigger: function (triggerProps) { return (React.createElement(AButton, __assign({ appearance: (props.platform === "micros") ? "default" : "primary", className: (props.platform === "micros") ? "button" : undefined }, triggerProps, { isSelected: isOpen, onClick: function () { return setIsOpen(!isOpen); } }), props.buttonText)); } }));
};
export default WizardHelp;
